import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, message } from 'antd';
import axiosInstance from '../../utils/axios';


const LanguageModal = ({ open, setOpen, languages, setLanguage, selectedId}) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [selectedItem, setSelectedItem] = useState(null);

	useEffect(() => {
		if (open) {
			if (selectedId !== null) {
				const item = languages.find(p => p.id === selectedId);
				setSelectedItem(item);

				if (item) {
					form.setFieldsValue({ name: item.name, alias: item.alias });
				}

			} else {
				setSelectedItem(null);
				form.resetFields();
			}
		}
	}, [open, selectedId, languages]);

	const handleCancel = () => {
    setOpen(false);
    form.resetFields();
    setSelectedItem(null);
  };

	const handleFinish = async (values) => {
    setLoading(true);

    try {
      let response;
      if (selectedItem) {
        response = await axiosInstance.patch(`core/language/${selectedItem.id}/`, values);
        setLanguage(prev => prev.map(p => (p.id === selectedItem.id ? response.data : p)));
        message.success("Language updated successfully!");

      } else {
        response = await axiosInstance.post(`core/language/`, values);
        setLanguage(prev => [...prev, response.data]);
        message.success("Language added successfully!");
      }

      form.resetFields();
      setOpen(false);
    } catch (error) {
      message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

	return (
		<Modal
			title={selectedItem ? "Edit Language" : "Add new Language"}
      open={open}
      onCancel={handleCancel}
      destroyOnHidden
      okButtonProps={{
        autoFocus: true,
        htmlType: 'submit',
        loading: loading,
        disabled: loading,
      }}
      onOk={() => form.submit()}
		>
 			<Form
        layout="vertical"
        form={form}
        name="language_form"
        onFinish={handleFinish}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: 'Please enter a language' }]}
        >
          <Input placeholder="Eg: malayalam" />
        </Form.Item>

        <Form.Item
          label="Alias"
          name="alias"
          rules={[{ required: true, message: 'Please enter an alias name' }]}
        >
          <Input placeholder="Eg: Mollywood" />
        </Form.Item>
      </Form>
		</Modal>
	)
}

export default LanguageModal